import {
  STATIC_MAP_ALL_LOCATIONS_API_PREFIX,
  STATIC_MAP_API_PREFIX,
} from '../constants';

type StaticMapUrlPrefix = typeof STATIC_MAP_API_PREFIX | typeof STATIC_MAP_ALL_LOCATIONS_API_PREFIX;

type StaticMapUrlParams = {
  /** Departure coordinates in format "longitude,latitude" */
  departGeo: string | undefined;
  /** Street coordinates in format "longitude,latitude" */
  streetGeo?: string;
  /** Map width in pixels */
  width: number;
  /** Map height in pixels */
  height: number;
  /** Optional zoom level */
  zoomLevel?: number;
  /** Optional language code e.g. 'en', 'ja' */
  lang?: string;
};

type StaticMapUrlOptions = {
  /** Static map url prefix */
  prefix?: StaticMapUrlPrefix;
};

const getStaticMapUrl = (
  params: StaticMapUrlParams,
  options: StaticMapUrlOptions = {},
): string | undefined => {
  const {
    departGeo,
    streetGeo,
    width,
    height,
    zoomLevel,
    lang,
  } = params;

  if (!departGeo || !width || !height) return undefined;

  const {
    prefix = STATIC_MAP_API_PREFIX,
  } = options;

  const queryParams = new URLSearchParams({
    depart_geo: departGeo,
    width: width.toString(),
    height: height.toString(),
  });

  if (streetGeo) {
    queryParams.set('street_geo', streetGeo);
  }

  if (zoomLevel) {
    queryParams.set('zoomlevel', zoomLevel.toString());
  }

  if (lang) {
    queryParams.set('lang', lang);
  }

  const mapUrl = `${prefix}?${queryParams.toString()}`;

  // Use environment variable for base URL in Storybook
  const envBaseUrl = process.env.NEXT_PUBLIC_STORYBOOK_BASE_URL;
  if (envBaseUrl) {
    return `${envBaseUrl}${mapUrl}`;
  }

  return mapUrl;
};

export default getStaticMapUrl;
